import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconLockOpenStyle0 = gravityIconIndividualCss;

const GravityIconLockOpen = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'fb3dec0fa123fb2c77b33532d971c679573b1ae8', color: this.color, size: this.size }, h("svg", { key: 'da3d0305e14dd8ccf68809df571ada0bac66f5a8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '64f987432ef8c11c22703c0684f4d96a81008ac7', d: "M10.25 15.49V13.8a1.5 1.5 0 1 1 1.5 0v1.69a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5Z", fill: "currentColor" }), h("path", { key: '3c5a1caceb61e18f438693c8b83225a8c4a6d3b8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 8H15V6.17A4.12 4.12 0 0 0 11.39 2 4 4 0 0 0 7 5.4a.52.52 0 0 0 .5.6H8a.49.49 0 0 0 .49-.4 2.5 2.5 0 0 1 2.73-2.09 2.61 2.61 0 0 1 2.28 2.64V8h-9a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5Zm-1 9.5h-11v-8h11v8Z", fill: "currentColor" }))));
    }
};
GravityIconLockOpen.style = GravityIconLockOpenStyle0;

export { GravityIconLockOpen as gravity_icon_lock_open };

//# sourceMappingURL=gravity-icon-lock-open.entry.js.map